<div class="ttmodal">
    <div class="ttmodal__header">
        <span class="ttmodal__title">Add Job Site</span>
        <i class="material-icons ttmodal__close-button" (click)="onNoClick()">close</i>
    </div>
    <div class="ttmodal__body">
        <span class="input-description">Please select the customer this job site belongs to. </span>
        <div class="input-container">
            <span class="label">Customer <span class="red-text">*</span></span>
            <span class="input-icon input-icon--mat">
                <i class="material-icons">people</i>
            </span>
            <select [(ngModel)]="selectedCustomerId" required class="get-select-text">
                <option value="0" disabled selected>Select Customer</option>
                <option *ngFor="let customer of customerList" [value]="customer.Id">{{customer.Name}}</option>
            </select>
        </div>
        <div class="input-container">
            <span class="label">Job Site Name <span class="red-text">*</span></span>
            <span class="input-icon input-icon--mat">
                <i class="material-icons">label</i>
            </span>
            <input [(ngModel)]="jobsiteName" type="text" placeholder="Minesite A" required>
        </div>

        <div class="input-container">
            <span class="label">Country <span class="red-text">*</span></span>
            <!--<input [(ngModel)]="country" type="text" placeholder="Australia" required>-->
            <select [(ngModel)]="countryId" required (change)="SelectCountry($event)" class="get-select-text">
                <option value="0" disabled selected>Select Country</option>
                <option *ngFor="let country of countryList" [value]="country.CountryCode">{{country.CountryName}}</option>
            </select>
        </div>
        
        <div *ngIf="showAll==false" style="display: flex;flex-direction: row;justify-content: center;">
            <i class="material-icons" (click)="ShowAllFields()">arrow_circle_down</i>
            <span style=" align-self: center;">Click here for more fields if required</span>
        </div>
        
        <div *ngIf="isBasicUser==1 || showAll==true">

        
        <div class="input-container">
            <span class="label">Job Site Type</span>
            <span class="input-icon input-icon--mat">
                <i class="material-icons">terrain</i>
            </span>
            <select [(ngModel)]="selectedJobsiteTypeId" required class="get-select-text">
                <option value="0" disabled selected>Select Job Site Type</option>
                <option *ngFor="let jobsiteType of jobsiteTypeList" [value]="jobsiteType.Id">{{jobsiteType.Title}}</option>
            </select>
        </div>
        <span class="input-description">Tell us some basic details about the job site.</span>
        
        <div class="input-container">
            <span class="label">Full Address <span class="red-text"></span></span>
            <span class="input-icon input-icon--mat">
                <i class="material-icons">location_on</i>
            </span>
            <input [(ngModel)]="fullAddress" type="text" placeholder="100 Example Road, Melbourne, Australia" #search [formControl]="searchControl" required>
        </div>
        <div class="input-container">
            <span class="label">City <span class="red-text"></span></span>
            <input [(ngModel)]="city" type="text" placeholder="Melbourne" required>
        </div>
        <div class="input-container">
            <span class="label">Post Code</span>
            <input [(ngModel)]="postCode" type="text" placeholder="1234">
        </div>
        <div class="input-container">
            <span class="label">State</span>
            <input [(ngModel)]="state" type="text" placeholder="Vic">
        </div>
       

        <div class="input-container">
            <span class="label">Latitude <span class="red-text"></span></span>
            <input [(ngModel)]="latitude" type="number" placeholder="Latitude" appDecimalpoints style="background: #f4f7fa;
            border: 1px solid transparent;
            border-radius: 0;
            outline: 0;
            width: auto;
            height: unset;
            font-size: 14px;
            margin: 0;
            padding: 12px 16px;
            box-sizing: border-box;
            transition: all .3s;
            flex-grow: 1;">
        </div>

        <div class="input-container">
            <span class="label">Longtitude <span class="red-text"></span></span>
            <input [(ngModel)]="longtitude" type="number" placeholder="Longtitude" appDecimalpoints style="background: #f4f7fa;
            border: 1px solid transparent;
            border-radius: 0;
            outline: 0;
            width: auto;
            height: unset;
            font-size: 14px;
            margin: 0;
            padding: 12px 16px;
            box-sizing: border-box;
            transition: all .3s;
            flex-grow: 1;">
        </div>
        </div>
    </div>
    <div class="ttmodal__footer">
        <a class="button margin-right-8" (click)="onNoClick()"><span class="button__text">Cancel</span></a>
        <a class="button button--primary" (click)="addNewJobsite()" [class.loading]="savingNewJobsite"><span class="button__text">Add Job Site</span></a>
    </div>
</div>
